import React from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import { Badge, Button, Divider } from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

import Analytics from "helpers/analytics";
import selectRmUser from "redux/reselect/cart/selectRMuser";
import Dropdown from "components/shared/Dropdown";
import CartItem from "./CartItem";

import CartHeaderWrapper from "../styles/Cart.style";

function Cart(props) {
  let { auth, removeFromCart, user, router, shopify } = props;

  const { cartItems } = user;

  const { pathname } = router.location;
  const pathnames = pathname.split("/");
  const isRMuser = selectRmUser(auth);

  const sumTotal = () =>
    cartItems.map((cart) => Number(cart.price) * cart.quantity).reduce((sub, num) => sub + num);
  let cartTotal = cartItems.length > 0 ? sumTotal().toFixed(2) : 0;
  let cartItemList = [];

  let cartParm = "";
  if (isRMuser) {
    const inPlaylist = pathname.startsWith("/licensing/account/lists/");
    const inCart = pathname.startsWith("/licensing/checkout/");
    if ((inPlaylist && pathnames.length > 4) || inCart || pathnames.length > 3) {
      if (inPlaylist || (!shopify.fetching && shopify.playlistInfo && inCart)) {
        cartItemList = user.cartItems.filter(
          (cart) => cart.playlistUUID === pathnames[inPlaylist ? 4 : 3]
        );
        cartTotal = cartItems.length > 0 ? sumTotal(cartItemList, "price").toFixed(2) : 0;
        cartParm = pathnames[inPlaylist ? 4 : 3];
      }
    }
  } else {
    cartItemList = user.cartItems;
  }

  const qty =
    cartItemList.length > 0 &&
    cartItemList.reduce((next, current) => ({
      quantity: next.quantity + current.quantity
    }));

  return (
    <CartHeaderWrapper className="cart-icon-nav">
      <Dropdown
        placement="bottom-end"
        buttonClass="filter--toggle"
        text={
          <>
            <ShoppingCartIcon className="cart--icon" />
            {cartItemList && Object.keys(cartItemList).length > 0 && (
              <Badge className="cart--counter" badgeContent={qty && qty.quantity} color="primary" />
            )}
          </>
        }
      >
        <>
          {cartItemList && Object.keys(cartItemList).length > 0 ? (
            <div>
              <div className="your-cart">
                <span className="cart--totalItem">Your Cart ({qty && qty.quantity})</span>
                {user.shopifyReady && (
                  <span>
                    <span className="subtotal--text">Subtotal: </span>
                    <NumberFormat
                      value={cartTotal}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </span>
                )}
              </div>

              <div className="cart__item__wrapper">
                {cartItemList.map((item, index) => (
                  <CartItem item={item} key={String(index)} removeFromCart={removeFromCart} />
                ))}
              </div>

              <div className="mini-cart-check-out">
                {process.env.REACT_APP_SHOPIFY_SHUTDOWN === "true" ? (
                  <p className="shopify-error">
                    Whoops! Our easy checkout is temporarily unavailable.
                  </p>
                ) : auth.loggedIn ? (
                  <Link
                    to={`/licensing/checkout${cartParm !== "" ? `/${cartParm}` : ""}`}
                    onClick={() => {
                      Analytics.track("View Cart", {
                        category: "LP-TopNav"
                      });
                    }}
                  >
                    <Button variant="contained">View Cart</Button>
                  </Link>
                ) : (
                  <Link
                    to="/licensing/login"
                    onClick={() => {
                      localStorage.setItem("prevPath", props.location.pathname);
                    }}
                  >
                    <Button variant="contained">View Cart</Button>
                  </Link>
                )}
              </div>
            </div>
          ) : (
            <div className="cart--empty">
              <div className="cart--message">Your cart is uninspired. Let’s change that.</div>
              <Divider />
              <div className="cart--search">
                <Link to="/licensing/search">
                  <Button variant="contained">SEARCH VIDEOS</Button>
                </Link>
              </div>
            </div>
          )}
        </>
      </Dropdown>
    </CartHeaderWrapper>
  );
}

export default Cart;
